/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserApiToken, selectCurrentUserM11Use } from "../../slices/currentUser/currentUserSlice";
import {
  m11ReportContainerFoiChanged, m11ReportContainerResourceChanged,
  m11ReportSection09FoiChanged, m11ReportSection09ResourceChanged, selectM11ReportContainerFoi,
  selectM11ReportContainerResource, selectM11ReportSection09Foi, selectM11ReportSection09Resource,
  selectM11ResearchStudyResource
} from "../../slices/m11ReportAuthoringTool/m11ReportAuthoringToolSlice";
import { useEffect, useState, useImperativeHandle, forwardRef } from "react";
import jsonEquals from "../../functions/jsonEquals";
import getIdFromReference from "../../functions/getIdFromReference";
import loadResource from "../m11ReportFunctions/loadResource";
import TextDivEntry from "./TextDivEntry";
import saveM11Changes from "../../functions/saveM11ChangesAPI";
import { selectM11ResearchStudyFoi } from "../../slices/m11StepCount/m11StepCountSlice";
import { validateStep } from "../../functions/validateM11ReportAPI";
import { Button, Dropdown, Table } from "semantic-ui-react";
import { TextField } from "@mui/material";

const saveAdverseEventsChanges = async (dispatch, apiToken, m11ResearchStudyFoi,
  section09State, setAlertModalState, setStartingSection09State) => {

  let changesStates = {
    section09State: section09State
  };
  let response = await saveM11Changes(apiToken, 31, m11ResearchStudyFoi, changesStates);
  if (response?.success) {
    if (response.m11ReportContainerResource) {
      dispatch(m11ReportContainerResourceChanged(response.m11ReportContainerResource));
    }
    if (response.m11ReportSection09Resource) {
      dispatch(m11ReportSection09ResourceChanged(response.m11ReportSection09Resource));
    }
    setStartingSection09State(JSON.parse(JSON.stringify(section09State)));
  } else {
    if (response.error) {
      alert(response.error);
    }
  }
};

const TableCodeEntry = ({ elementName, fieldLabel, startingValue, index, setTableDataState, allowedValues }) => {
  if (!allowedValues) {
    return <></>
  }
  return <Table.Cell style={{ paddingRight: "0px", paddingTop: "8px", paddingBottom: "8px", verticalAlign: "top" }}>
    <Dropdown
      name={elementName}
      placeholder={fieldLabel}
      search={true}
      closeOnChange selection clearable selectOnBlur={false} autoComplete='off'
      style={{ minWidth: "100px", width: "100%" }}
      options={allowedValues.map((code, codeIndex) => { return { "key": codeIndex, "value": code, "text": code } })}
      value={startingValue}
      onChange={(e, data) => {
        setTableDataState(prevState => {
          let newArray = JSON.parse(JSON.stringify(prevState.tabledata));
          newArray[index][elementName] = data.value;
          return { ...prevState, "tabledata": newArray };
        });
      }}
    />
  </Table.Cell>
};

const TableStringEntry = ({ startingValue, fieldLabel, index, setTableDataState, elementName }) => {
  return <Table.Cell style={{ paddingRight: "0px", paddingTop: "8px", paddingBottom: "8px", verticalAlign: "top" }}>
    <TextField style={{ width: "100%" }} multiline className="inputField" type='text'
      label={fieldLabel} size="small" variant='outlined'
      value={startingValue || ''}
      onChange={(e) => {
        setTableDataState(prevState => {
          let newArray = JSON.parse(JSON.stringify(prevState.tabledata));
          newArray[index][elementName] = e.target.value;
          return { ...prevState, "tabledata": newArray };
        });
      }} />
  </Table.Cell>
}

const TableEntry = ({ tabledata, setTableDataState }) => {

  return <>
    <Table>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell style={{ width: "14%" }}>Event Type</Table.HeaderCell>
          <Table.HeaderCell style={{ width: "14%" }}>Situational Scope</Table.HeaderCell>
          <Table.HeaderCell style={{ width: "14%" }}>Reportable Period Start</Table.HeaderCell>
          <Table.HeaderCell style={{ width: "14%" }}>Reportable Period End</Table.HeaderCell>
          <Table.HeaderCell style={{ width: "14%" }}>Timing for Reporting to Sponsor or Designee</Table.HeaderCell>
          <Table.HeaderCell style={{ width: "14%" }}>Method for Reporting</Table.HeaderCell>
          <Table.HeaderCell style={{ width: "14%" }}>Back-up Method for Reporting</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {tabledata?.map((tablerow, index) => {
          return <Table.Row key={index}>
            <TableCodeEntry startingValue={tablerow.eventType}
              fieldLabel='Event Type'
              elementName="eventType"
              allowedValues={["Adverse Event", "Serious Adverse Event",
                "Trial Intervention Complaint", "Drug/Device Combination Product Complaint",
                "Pregnancy Event", "Lactation Event", "Post-Partum Event",
                "Reportable Adverse Event of Special Interest",
                "Not Reportable Adverse Event of Special Interest", "Other"]}
              index={index} setTableDataState={setTableDataState} />
            <TableStringEntry startingValue={tablerow.situationalScope}
              fieldLabel='Situational Scope'
              elementName="situationalScope"
              index={index} setTableDataState={setTableDataState} />
            <TableStringEntry startingValue={tablerow.start}
              fieldLabel='Reportable Period Start'
              elementName="start"
              index={index} setTableDataState={setTableDataState} />
            <TableStringEntry startingValue={tablerow.end}
              fieldLabel='Reportable Period End'
              elementName="end"
              index={index} setTableDataState={setTableDataState} />
            <TableStringEntry startingValue={tablerow.timing}
              fieldLabel='Timing for Reporting to Sponsor or Designee'
              elementName="timing"
              index={index} setTableDataState={setTableDataState} />
            <TableStringEntry startingValue={tablerow.method}
              fieldLabel='Method for Reporting'
              elementName="method"
              index={index} setTableDataState={setTableDataState} />
            <TableStringEntry startingValue={tablerow.backup}
              fieldLabel='Back-up Method for Reporting'
              elementName="backup"
              index={index} setTableDataState={setTableDataState} />
          </Table.Row>;
        })
        }
      </Table.Body>
    </Table>
    <span>
      <Button className="formButton" style={{ color: "#000000" }}
        content='+Add Row'
        onClick={() => {
          setTableDataState(prevState => {
            let newArray = [{}];
            if (prevState.tabledata) {
              newArray = prevState.tabledata.concat([{}]);
            }
            return { ...prevState, "tabledata": newArray };
          });
        }} />
    </span>
  </>
};

const M11Step031AdverseEventsProcedures = forwardRef(({ theM11ResearchStudyFoi, setAlertModalState }, ref) => {

  const dispatch = useDispatch();
  const apiToken = useSelector(selectCurrentUserApiToken);
  const m11User = useSelector(selectCurrentUserM11Use);
  const m11ResearchStudyResource = useSelector(selectM11ResearchStudyResource);
  const m11ReportContainerFoi = useSelector(selectM11ReportContainerFoi);
  const m11ReportContainerResource = useSelector(selectM11ReportContainerResource);
  const m11ReportSection09Foi = useSelector(selectM11ReportSection09Foi);
  const m11ReportSection09Resource = useSelector(selectM11ReportSection09Resource);
  const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

  const [section09State, setSection09State] = useState({
    "section92Status": "empty",
    "section92Xhtml": '<div xmlns="http://www.w3.org/1999/xhtml"><p>[Replace this line with content and/or use the table.]</p></div>',
    "section921Status": "empty", "section921Xhtml": "",
    "section922IdentificationStatus": "empty", "section922IdentificationXhtml": "",
    "section922SeverityStatus": "empty", "section922SeverityXhtml": "",
    "section922CausalityStatus": "empty", "section922CausalityXhtml": "",
    "section922RecordingStatus": "empty", "section922RecordingXhtml": "",
    "section922FollowupStatus": "empty", "section922FollowupXhtml": "",
    "section923Status": "empty", "section923Xhtml": "",
    "section9231Status": "empty", "section9231Xhtml": "",
    "section924Status": "empty", "section924Xhtml": "",
    "section925Status": "empty", "section925Xhtml": ""
  });
  const [startingSection09State, setStartingSection09State] = useState({
    "section92Status": "empty",
    "section92Xhtml": '<div xmlns="http://www.w3.org/1999/xhtml"><p>[Replace this line with content and/or use the table.]</p></div>',
    "section921Status": "empty", "section921Xhtml": "",
    "section922IdentificationStatus": "empty", "section922IdentificationXhtml": "",
    "section922SeverityStatus": "empty", "section922SeverityXhtml": "",
    "section922CausalityStatus": "empty", "section922CausalityXhtml": "",
    "section922RecordingStatus": "empty", "section922RecordingXhtml": "",
    "section922FollowupStatus": "empty", "section922FollowupXhtml": "",
    "section923Status": "empty", "section923Xhtml": "",
    "section9231Status": "empty", "section9231Xhtml": "",
    "section924Status": "empty", "section924Xhtml": "",
    "section925Status": "empty", "section925Xhtml": ""
  });
  const [initialCalculationNeeded, setInitialCalculationNeeded] = useState(false);
  const [tableDataState, setTableDataState] = useState({ tabledata: [{}] });
  const [remount, setRemount] = useState(1);

  const replaceWithTable = () => {
    if (tableDataState.tabledata.length > 0 && Object.keys(tableDataState.tabledata[0]).length > 0) {
      let section92Xhtml = '<div xmlns="http://www.w3.org/1999/xhtml">';
      section92Xhtml += "<p>This table describes the timing and procedures for collecting and reporting events.</p>";
      section92Xhtml += "<table><tbody><tr><td>Event Type</td><td>Situational Scope</td><td>Reportable Period Start</td><td>Reportable Period End</td><td>Timing for Reporting to Sponsor or Designee</td><td>Method for Reporting</td><td>Back-up Method for Reporting</td></tr>";
      for (const row of tableDataState.tabledata) {
        section92Xhtml += "<tr><td>" + row.eventType + "</td><td>" + row.situationalScope + "</td><td>" +
          row.start + "</td><td>" + row.end + "</td><td>" + row.timing +
          "</td><td>" + row.method + "</td><td>" + row.backup + "</td></tr>";
      }
      section92Xhtml += "</tbody></table></div>";
      setSection09State(prevState => {
        return {
          ...prevState,
          "section92Status": "additional",
          "section92Xhtml": section92Xhtml
        }
      })
      setRemount(prevState => prevState + 1);
    } else {
      alert("Enter data in the table first.");
    }
  };

  useImperativeHandle(ref, () => ({
    unsavedChanges: (m11ResearchStudyResource && !jsonEquals(section09State, startingSection09State)),
    async saveAllChanges() {
      await saveAdverseEventsChanges(dispatch, apiToken, m11ResearchStudyFoi,
        section09State, setAlertModalState, setStartingSection09State);
    }
  }));

  useEffect(() => {
    if (m11ResearchStudyResource?.id) {
      let m11ReportFoi = "";
      if (m11ResearchStudyResource.relatesTo?.length > 0) {
        for (let relatesTo of m11ResearchStudyResource.relatesTo) {
          if (relatesTo.type?.coding?.[0]?.code === "supported-with" && relatesTo.type.text === "M11 Report" &&
            relatesTo.targetReference) {
            m11ReportFoi = getIdFromReference(relatesTo.targetReference);
          }
        }
      }
      if (m11ReportFoi && !isNaN(m11ReportFoi) && m11ReportFoi !== m11ReportContainerFoi) {
        dispatch(m11ReportContainerFoiChanged(m11ReportFoi));
      } else {
        setInitialCalculationNeeded(true);
      }
    }
  }, [m11ResearchStudyResource]);

  useEffect(() => {
    if (initialCalculationNeeded === true) {
      let startingData = {
        "section92Status": "empty",
        "section92Xhtml": '<div xmlns="http://www.w3.org/1999/xhtml"><p>[Replace this line with content and/or use the table.]</p></div>',
        "section921Status": "empty", "section921Xhtml": "",
        "section922IdentificationStatus": "empty", "section922IdentificationXhtml": "",
        "section922SeverityStatus": "empty", "section922SeverityXhtml": "",
        "section922CausalityStatus": "empty", "section922CausalityXhtml": "",
        "section922RecordingStatus": "empty", "section922RecordingXhtml": "",
        "section922FollowupStatus": "empty", "section922FollowupXhtml": "",
        "section923Status": "empty", "section923Xhtml": "",
        "section9231Status": "empty", "section9231Xhtml": "",
        "section924Status": "empty", "section924Xhtml": "",
        "section925Status": "empty", "section925Xhtml": "",
        "loaded": true
      };
      setSection09State(startingData);
      setStartingSection09State(startingData);
    }
  }, [initialCalculationNeeded]);

  useEffect(() => {
    if (m11ReportContainerFoi && !isNaN(m11ReportContainerFoi)) {
      loadResource(m11ReportContainerFoi, "M11ReportContainer", apiToken, dispatch);
    }
  }, [m11ReportContainerFoi]);

  useEffect(() => {
    if (m11ReportContainerResource && Object.keys(m11ReportContainerResource).length > 0) {
      if (m11ReportContainerResource.section?.[9]?.entry?.length) {
        let m11ReportSection009Foi = getIdFromReference(m11ReportContainerResource.section[9].entry[0]);
        if (m11ReportSection009Foi && !isNaN(m11ReportSection009Foi) && m11ReportSection009Foi !== m11ReportSection09Foi) {
          dispatch(m11ReportSection09FoiChanged(m11ReportSection009Foi));
        } else {
          setInitialCalculationNeeded(true);
        }
      } else {
        setInitialCalculationNeeded(true);
      }
    }
  }, [m11ReportContainerResource]);

  useEffect(() => {
    if (m11ReportSection09Foi && !isNaN(m11ReportSection09Foi)) {
      loadResource(m11ReportSection09Foi, "M11ReportSection09", apiToken, dispatch);
    }
  }, [m11ReportSection09Foi]);

  useEffect(() => {
    if (m11ReportSection09Resource && Object.keys(m11ReportSection09Resource).length > 0) {
      let startingData = {
        "section92Status": "empty",
        "section92Xhtml": '<div xmlns="http://www.w3.org/1999/xhtml"><p>[Replace this line with content and/or use the table.]</p></div>',
        "section921Status": "empty", "section921Xhtml": "",
        "section922IdentificationStatus": "empty", "section922IdentificationXhtml": "",
        "section922SeverityStatus": "empty", "section922SeverityXhtml": "",
        "section922CausalityStatus": "empty", "section922CausalityXhtml": "",
        "section922RecordingStatus": "empty", "section922RecordingXhtml": "",
        "section922FollowupStatus": "empty", "section922FollowupXhtml": "",
        "section923Status": "empty", "section923Xhtml": "",
        "section9231Status": "empty", "section9231Xhtml": "",
        "section924Status": "empty", "section924Xhtml": "",
        "section925Status": "empty", "section925Xhtml": "",
        "loaded": true
      };
      if (m11ReportSection09Resource.section?.[0]?.section?.length > 0) {
        if (m11ReportSection09Resource.section[0].section[1]?.text?.div &&
          m11ReportSection09Resource.section[0].section[1].text.status !== "empty") {
          startingData.section92Status = m11ReportSection09Resource.section[0].section[1].text.status;
          startingData.section92Xhtml = m11ReportSection09Resource.section[0].section[1].text.div;
        }
        if (m11ReportSection09Resource.section[0].section[1]?.section?.length > 0) {
          if (m11ReportSection09Resource.section[0].section[1].section[0]?.text?.div &&
            m11ReportSection09Resource.section[0].section[1].section[0].text.status !== "empty") {
            startingData.section921Status = m11ReportSection09Resource.section[0].section[1].section[0].text.status;
            startingData.section921Xhtml = m11ReportSection09Resource.section[0].section[1].section[0].text.div;
          }
          if (m11ReportSection09Resource.section[0].section[1].section[1]?.section?.[0]?.text?.div &&
            m11ReportSection09Resource.section[0].section[1].section[1].section[0].text.status !== "empty") {
            startingData.section922IdentificationStatus = m11ReportSection09Resource.section[0].section[1].section[1].section[0].text.status;
            startingData.section922IdentificationXhtml = m11ReportSection09Resource.section[0].section[1].section[1].section[0].text.div;
          }
          if (m11ReportSection09Resource.section[0].section[1].section[1]?.section?.[1]?.text?.div &&
            m11ReportSection09Resource.section[0].section[1].section[1].section[1].text.status !== "empty") {
            startingData.section922SeverityStatus = m11ReportSection09Resource.section[0].section[1].section[1].section[1].text.status;
            startingData.section922SeverityXhtml = m11ReportSection09Resource.section[0].section[1].section[1].section[1].text.div;
          }
          if (m11ReportSection09Resource.section[0].section[1].section[1]?.section?.[2]?.text?.div &&
            m11ReportSection09Resource.section[0].section[1].section[1].section[2].text.status !== "empty") {
            startingData.section922CausalityStatus = m11ReportSection09Resource.section[0].section[1].section[1].section[2].text.status;
            startingData.section922CausalityXhtml = m11ReportSection09Resource.section[0].section[1].section[1].section[2].text.div;
          }
          if (m11ReportSection09Resource.section[0].section[1].section[1]?.section?.[3]?.text?.div &&
            m11ReportSection09Resource.section[0].section[1].section[1].section[3].text.status !== "empty") {
            startingData.section922RecordingStatus = m11ReportSection09Resource.section[0].section[1].section[1].section[3].text.status;
            startingData.section922RecordingXhtml = m11ReportSection09Resource.section[0].section[1].section[1].section[3].text.div;
          }
          if (m11ReportSection09Resource.section[0].section[1].section[1]?.section?.[4]?.text?.div &&
            m11ReportSection09Resource.section[0].section[1].section[1].section[4].text.status !== "empty") {
            startingData.section922FollowupStatus = m11ReportSection09Resource.section[0].section[1].section[1].section[4].text.status;
            startingData.section922FollowupXhtml = m11ReportSection09Resource.section[0].section[1].section[1].section[4].text.div;
          }
          if (m11ReportSection09Resource.section[0].section[1].section[2]?.text?.div &&
            m11ReportSection09Resource.section[0].section[1].section[2].text.status !== "empty") {
            startingData.section923Status = m11ReportSection09Resource.section[0].section[1].section[2].text.status;
            startingData.section923Xhtml = m11ReportSection09Resource.section[0].section[1].section[2].text.div;
          }
          if (m11ReportSection09Resource.section[0].section[1].section[2]?.section?.[0]?.text?.div &&
            m11ReportSection09Resource.section[0].section[1].section[2].section[0].text.status !== "empty") {
            startingData.section9231Status = m11ReportSection09Resource.section[0].section[1].section[2].section[0].text.status;
            startingData.section9231Xhtml = m11ReportSection09Resource.section[0].section[1].section[2].section[0].text.div;
          }
          if (m11ReportSection09Resource.section[0].section[1].section[3]?.text?.div &&
            m11ReportSection09Resource.section[0].section[1].section[3].text.status !== "empty") {
            startingData.section924Status = m11ReportSection09Resource.section[0].section[1].section[3].text.status;
            startingData.section924Xhtml = m11ReportSection09Resource.section[0].section[1].section[3].text.div;
          }
          if (m11ReportSection09Resource.section[0].section[1].section[4]?.text?.div &&
            m11ReportSection09Resource.section[0].section[1].section[4].text.status !== "empty") {
            startingData.section925Status = m11ReportSection09Resource.section[0].section[1].section[4].text.status;
            startingData.section925Xhtml = m11ReportSection09Resource.section[0].section[1].section[4].text.div;
          }
        }
        setSection09State(startingData);
        setStartingSection09State(startingData);
      } else {
        setInitialCalculationNeeded(true);
      }
    }
  }, [m11ReportSection09Resource]);

  return <div>
    <h3>Complete Section 9.2 Timing and Procedures for Collection and Reporting</h3>
    {!(m11ReportSection09Resource?.id || m11ReportContainerResource?.id) &&
      <h1 style={{ color: "red" }}>Please complete Step 5 (Complete Title Page) before filling in M11 Report Section details.</h1>
    }
    {m11User === "sample" ?
      <div style={{ outline: "1px solid #000000", padding: "6px", width: "fit-content" }}>
        <h2>You are using the M11 Report Authoring Tool (Test Drive Version).</h2>
        <p style={{ color: "red" }}>Step 31 (Complete Section 9.2 Timing and Procedures for Collection and Reporting) is not included in the M11 Report Authoring Tool (Test Drive Version).</p>
        <p>Subscribe to the M11 Report Authoring Tool (Professional Version) for complete functionality.</p>
      </div>
      :
      <>
        {section09State.loaded && <>
          <h4 style={{ marginBottom: "0px" }}>Enter data for Section 9.2 Timing and Procedures for Collection and Reporting.</h4>
          <p>Consider the optional table.</p>
          <div style={{ marginLeft: "24px" }} >
            <p>Enter data in each cell of the table.</p>
            <p>Add rows as needed.</p>
            <p>Click to replace the summary below with the table.</p>
          </div>
          <TableEntry tabledata={tableDataState.tabledata} setTableDataState={setTableDataState} />
          <Button className="formButton navigationButton"
            style={{
              color: "#000000",
              fontSize: "20px",
              width: "100%",
              margin: "0px"
            }}
            content="Replace Section 9.2 summary with Table."
            onClick={() => {
              replaceWithTable();
            }}
          />
          {remount && <TextDivEntry elementName="section92Xhtml" key={remount}
            startingValue={section09State.section92Xhtml}
            setResourceState={setSection09State} />}
          <h4 style={{ marginBottom: "0px" }}>Revise the Section 9.2.1 Timing as needed.</h4>
          <TextDivEntry elementName="section921Xhtml"
            startingValue={section09State.section921Xhtml}
            setResourceState={setSection09State} />
          <h4 style={{ marginBottom: "0px" }}>Revise the Section 9.2.2 Collection Procedures as needed in the sections below.</h4>
          <h5 style={{ marginBottom: "0px" }}>Identification</h5>
          <TextDivEntry elementName="section922IdentificationXhtml"
            startingValue={section09State.section922IdentificationXhtml}
            setResourceState={setSection09State} />
          <h5 style={{ marginBottom: "0px" }}>Severity</h5>
          <TextDivEntry elementName="section922SeverityXhtml"
            startingValue={section09State.section922SeverityXhtml}
            setResourceState={setSection09State} />
          <h5 style={{ marginBottom: "0px" }}>Causality</h5>
          <TextDivEntry elementName="section922CausalityXhtml"
            startingValue={section09State.section922CausalityXhtml}
            setResourceState={setSection09State} />
          <h5 style={{ marginBottom: "0px" }}>Recording</h5>
          <TextDivEntry elementName="section922RecordingXhtml"
            startingValue={section09State.section922RecordingXhtml}
            setResourceState={setSection09State} />
          <h5 style={{ marginBottom: "0px" }}>Follow-up</h5>
          <TextDivEntry elementName="section922FollowupXhtml"
            startingValue={section09State.section922FollowupXhtml}
            setResourceState={setSection09State} />
          <h4 style={{ marginBottom: "0px" }}>Revise the Section 9.2.3 Reporting as needed.</h4>
          <TextDivEntry elementName="section923Xhtml"
            startingValue={section09State.section923Xhtml}
            setResourceState={setSection09State} />
          <h4 style={{ marginBottom: "0px" }}>Revise the Section 9.2.3.1 Regulatory Reporting Requirements summary as needed.</h4>
          <TextDivEntry elementName="section9231Xhtml"
            startingValue={section09State.section9231Xhtml}
            setResourceState={setSection09State} />
          <h4 style={{ marginBottom: "0px" }}>Revise the Section 9.2.4 Adverse Events of Special Interest as needed.</h4>
          <TextDivEntry elementName="section924Xhtml"
            startingValue={section09State.section924Xhtml}
            setResourceState={setSection09State} />
          <h4 style={{ marginBottom: "0px" }}>Revise the Section 9.2.5 Disease-related Events or Outcomes Not Qualifying as AEs or SAEs as needed.</h4>
          <TextDivEntry elementName="section925Xhtml"
            startingValue={section09State.section925Xhtml}
            setResourceState={setSection09State} />
        </>}
      </>
    }
  </div >
});

const M11Step031AdverseEventsProceduresHelperText = <div>
  <h3>Complete Section 9.2 Timing and Procedures for Collection and Reporting</h3>
  <div style={{ textAlign: "left" }}>
    <p>Enter data for Section 9.2 Timing and Procedures for Collection and Reporting.</p>
    <div style={{ marginLeft: "24px" }} >
      <p>Specify timing and procedures for collection and reporting of AEs, SAEs, product complaints (including medical device product complaints if applicable) and pregnancy and postpartum information in the sections below. This information may be summarised in a tabular format as shown in the example table below.</p>
      <p>Consider the optional table.</p>
      <div style={{ marginLeft: "24px" }} >
        <p>Enter data in each cell of the table.</p>
        <p>Add rows as needed.</p>
        <p>Delete the table if not used, and if so, delete the line stating 'This table describes the timing and procedures for collecting and reporting events.'</p>
      </div>
    </div>
    <p>Enter data for Section 9.2.1 Timing.</p>
    <div style={{ marginLeft: "24px" }} >
      <p>Specify timing for collection and reporting, including:</p>
      <div style={{ marginLeft: "24px" }} >
        <p>•	start and end dates for collection and reporting</p>
        <p>•	frequency of collection and reporting</p>
        <p>•	cross reference to the Schedule of Assessments as appropriate</p>
      </div>
    </div>
    <p>Enter data for Section 9.2.2 Collection Procedures.</p>
    <div style={{ marginLeft: "24px" }} >
      <p>Specify procedures for collection and recording of AEs, SAEs, product complaints (including medical device product complaints if applicable) and pregnancy and postpartum information in the sections below.</p>
      <div style={{ marginLeft: "24px" }} >
        <p><b>Identification:</b> Specify how information will be identified (e.g., self-reported, solicited questions).</p>
        <p><b>Severity:</b> Specify the intensity rating categories/scale.</p>
        <p><b>Causality:</b> Specify the causality categories/scale, and procedures for assessing causality.</p>
        <p><b>Recording:</b> Specify procedures for recording.</p>
        <p><b>Follow-up:</b> Specify the procedures for follow-up. Include the assessment tools that will be used to monitor the events and the duration of follow-up after appearance of the events.</p>
      </div>
    </div>
    <p>Enter data for Section 9.2.3 Reporting.</p>
    <div style={{ marginLeft: "24px" }} >
      <p>Specify the reporting method (e.g., an electronic data collection tool or a paper CRF), backup reporting method, if applicable, and reporting timeline to the sponsor.</p>
    </div>
    <p>Enter data for Section 9.2.3.1 Regulatory Reporting Requirements.</p>
    <div style={{ marginLeft: "24px" }} >
      <p>Specify:</p>
      <div style={{ marginLeft: "24px" }} >
        <p>•	the investigator’s responsibilities for reporting to the sponsor (and to ethics committees, where required), specifying timing of reporting to allow the sponsor to meet their responsibilities</p>
        <p>•	the sponsor’s legal/regulatory responsibilities for reporting to regulatory authorities, ethics committees, and investigators</p>
        <p>•	suspected unexpected serious adverse reaction reporting</p>
      </div>
    </div>
    <p>Enter data for Section 9.2.4 Adverse Events of Special Interest.</p>
    <div style={{ marginLeft: "24px" }} >
      <p>Enter data as noted below or enter 'Not Applicable'</p>
      <p>Specify any AESI, including:</p>
      <div style={{ marginLeft: "24px" }} >
        <p>•	any event (serious or nonserious) of scientific and medical concern relative to the trial intervention, for which ongoing monitoring and rapid communication by the investigator to the sponsor can be appropriate</p>
        <p>•	other events that merit reporting to the sponsor, trial leadership, IRB, and regulatory agencies</p>
      </div>
      <p>Include the following for each AESI:</p>
      <div style={{ marginLeft: "24px" }} >
        <p>•	the definition</p>
        <p>•	the approach for ascertaining information</p>
        <p>•	if applicable, any approach to confirm or adjudicate the event</p>
      </div>
    </div>
    <p>Enter data for Section 9.2.5 Disease-related Events or Outcomes Not Qualifying as AEs or SAEs.</p>
    <div style={{ marginLeft: "24px" }} >
      <p>Specify any DREs, DROs, or both that will not be reported as AEs or SAEs (e.g., seizures in anticonvulsant trials) or state “Not applicable.”</p>
    </div>
    <p>Click the 'Save All Changes' button.</p>
  </div>
</div>;

// eslint-disable-next-line no-empty-pattern
const M11Step031AdverseEventsProceduresValidationCheck = ({ }) => {

  const apiToken = useSelector(selectCurrentUserApiToken);
  const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

  const [validationCheckState, setValidationCheckState] = useState({});

  useEffect(() => {
    if (m11ResearchStudyFoi) {
      validateStep(apiToken, 31, m11ResearchStudyFoi,
        setValidationCheckState)
    }
  }, [m11ResearchStudyFoi]);

  return <div>{validationCheckState?.success && <div>
    <h4>Step 31 (Complete Section 9.2 Timing and Procedures for Collection and Reporting) {validationCheckState.step31numberOfChecks} issues checked. {validationCheckState.step31numberPassed} passed. {validationCheckState.step31numberFailed} failed.</h4>
    <p>Section 9.2 heading is 'Timing and Procedures for Collection and Reporting': {validationCheckState.resultCheckSection92Heading}</p>
    <p>Section 9.2.1 heading is 'Timing': {validationCheckState.resultCheckSection921Heading}</p>
    <p>Section 9.2.1 Timing has content: {validationCheckState.resultCheckSection921Content}</p>
    <p>Section 9.2.2 heading is 'Collection Procedures': {validationCheckState.resultCheckSection922Heading}</p>
    <p>Section 9.2.2 Collection Procedures contains heading of 'Identification': {validationCheckState.resultCheckSection922HeadingIdentification}</p>
    <p>Section 9.2.2 Collection Procedures - Identification has content: {validationCheckState.resultCheckSection922ContentIdentification}</p>
    <p>Section 9.2.2 Collection Procedures contains heading of 'Severity': {validationCheckState.resultCheckSection922HeadingSeverity}</p>
    <p>Section 9.2.2 Collection Procedures - Severity has content: {validationCheckState.resultCheckSection922ContentSeverity}</p>
    <p>Section 9.2.2 Collection Procedures contains heading of 'Causality': {validationCheckState.resultCheckSection922HeadingCausality}</p>
    <p>Section 9.2.2 Collection Procedures - Causality has content: {validationCheckState.resultCheckSection922ContentCausality}</p>
    <p>Section 9.2.2 Collection Procedures contains heading of 'Recording': {validationCheckState.resultCheckSection922HeadingRecording}</p>
    <p>Section 9.2.2 Collection Procedures - Recording has content: {validationCheckState.resultCheckSection922ContentRecording}</p>
    <p>Section 9.2.2 Collection Procedures contains heading of 'Follow-up': {validationCheckState.resultCheckSection922HeadingFollowup}</p>
    <p>Section 9.2.2 Collection Procedures - Follow-up has content: {validationCheckState.resultCheckSection922ContentFollowup}</p>
    <p>Section 9.2.3 heading is 'Reporting': {validationCheckState.resultCheckSection923Heading}</p>
    <p>Section 9.2.3 Reporting has content: {validationCheckState.resultCheckSection923Content}</p>
    <p>Section 9.2.3.1 heading is 'Regulatory Reporting Requirements': {validationCheckState.resultCheckSection9231Heading}</p>
    <p>Section 9.2.3.1 Regulatory Reporting Requirements has content: {validationCheckState.resultCheckSection9231Content}</p>
    <p>Section 9.2.4 heading is 'Adverse Events of Special Interest': {validationCheckState.resultCheckSection924Heading}</p>
    <p>Section 9.2.4 Adverse Events of Special Interest has content: {validationCheckState.resultCheckSection924Content}</p>
    <p>Section 9.2.5 heading is 'Disease-related Events or Outcomes Not Qualifying as AEs or SAEs': {validationCheckState.resultCheckSection925Heading}</p>
    <p>Section 9.2.5 Disease-related Events or Outcomes Not Qualifying as AEs or SAEs has content: {validationCheckState.resultCheckSection925Content}</p>
  </div>}  </div>
}

export default M11Step031AdverseEventsProcedures;
export { M11Step031AdverseEventsProceduresHelperText, M11Step031AdverseEventsProceduresValidationCheck };